import { Tooltip, Typography, TypographyProps } from "@mui/material";
import { SxProps, Theme } from "@mui/material/styles";
import { HighlightedText } from "src/components/common/HighlightedText";
import { hoverEmail, userDisplayName } from "src/utils/userDisplay";

interface UserIdentity {
  name?: string | null;
  email?: string | null;
}

/** Renders a user's name, with their email address shown on hover. */
export const UserLabel = ({
  user,
  variant = "body2",
  sx,
  highlight,
}: {
  user: UserIdentity | null | undefined;
  variant?: TypographyProps["variant"];
  sx?: SxProps<Theme>;
  highlight?: string;
}) => {
  const displayName = userDisplayName(user);
  const email = hoverEmail(user);

  const label = (
    <Typography variant={variant} component="span" sx={sx}>
      <HighlightedText text={displayName} query={highlight} />
    </Typography>
  );

  if (!email || email === displayName) {
    return label;
  }

  return <Tooltip title={email}>{label}</Tooltip>;
};
